const doc = [({"installment":"Pago a plazos", "limited_subscription":"Suscripción limitada", "one_time":"Pago único", "subscription":"Suscripción"})];
module.exports = doc.length <= 1 ? doc[0] : doc;